<div class="container-fluid">
  <div class="row fondoAmarillo registro-nav">
    <div class="col-lg-2 col-md-3">
      <img src="assets/img/auri.png" alt="Auri" height="60px">
    </div>
    <div class="col-lg-8 col-md-6 bienvenida">
      <p class="center blanco">¡Bienvenido <span class="bold">{{datos?.nombre}}</span>!</p>
    </div>
    <div class="col-lg-2 col-md-3 cerrar-sesion">
      <a class="blanco bold" (click)="cerrarSesion()">Cerrar Sesión</a>
    </div>
  </div>
</div>

<ng-template #comprobantePagoModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-comprobante-pago">Comprobante de pago</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="alert alert-info" *ngIf="getComprobantePagoUrl()">
      <strong>Archivo actual:</strong>
      <a [href]="getComprobantePagoUrl()" target="_blank" rel="noopener">
        {{ comprobantePago?.nombre || 'Ver comprobante' }}
      </a>
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Subir comprobante</label>
      <input class="form-control-file" type="file" accept="image/*,.pdf" (change)="onComprobantePagoChange($event.target.files)">
    </div>
    <div class="alert alert-success" *ngIf="comprobanteMensaje">{{comprobanteMensaje}}</div>
    <div class="alert alert-danger" *ngIf="comprobanteError">{{comprobanteError}}</div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cerrar</button>
    <button type="button" class="btn btn-warning" (click)="subirComprobantePago()" [disabled]="subiendoComprobante">
      {{subiendoComprobante ? 'Subiendo...' : 'Guardar comprobante'}}
    </button>
  </div>
</ng-template>

<div class="container pago-container">
  <div *ngIf="cargando" class="text-center">Cargando información de pago…</div>
  <div *ngIf="error" class="alert alert-danger">{{error}}</div>

  <div *ngIf="datos && !cargando" class="row">
    <div class="col-lg-6">
      <h4>Confirma tu paquete</h4>
      <div class="resumen">
        <div *ngFor="let item of datos.paquetes" class="resumen-item">
          <span>{{item.paquete}}</span><strong>${{item.precio | number:'1.2-2'}}</strong>
        </div>
        <div *ngFor="let item of datos.productos" class="resumen-item">
          <span>{{item.producto}}</span><strong>${{item.precio | number:'1.2-2'}}</strong>
        </div>
        <div *ngFor="let item of datos.viajes" class="resumen-item">
          <span>{{item.nombre}}</span><strong>${{item.precio | number:'1.2-2'}}</strong>
        </div>
        <div *ngFor="let item of datos.anillos" class="resumen-item">
          <span>{{item.nombre}}</span><strong>${{item.precio | number:'1.2-2'}}</strong>
        </div>
        <div class="resumen-item total-paquete">
          <span>Total del paquete</span><strong>${{datos.total | number:'1.2-2'}}</strong>
        </div>

        <button class="btn text-white btn-md mt-5 mb-2 mt-sm-0 bg-primary" type="button" (click)="abrirComprobantePago(comprobantePagoModal)">
          Subir Comprobante
        </button>

      </div>
    </div>


    <div class="col-lg-6">
      <div class="pago-card">
        <div class="d-flex align-items-center justify-content-between flex-wrap">
          <h4 class="mb-0">Realizar pago</h4>
        </div>
        <p class="monto">Saldo disponible para pagar: <strong>${{montoMaximo | number:'1.2-2'}}</strong></p>
        <div class="monto-selector">
          <label for="monto-pago">Monto a pagar</label>
          <input
            id="monto-pago"
            class="form-control"
            type="number"
            inputmode="decimal"
            step="1"
            [min]="montoMinimo"
            [max]="montoMaximo"
            [(ngModel)]="montoPago"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onMontoPagoChange()">
          <small>Minimo ${{montoMinimo | number:'1.2-2'}} - Maximo ${{montoMaximo | number:'1.2-2'}}</small>
          <div class="alert alert-danger mt-2 mb-0" *ngIf="montoError">{{montoError}}</div>
        </div>
        <div class="comprobante-estado" *ngIf="getComprobantePagoUrl()">
          <span>Comprobante cargado</span>
          <a [href]="getComprobantePagoUrl()" target="_blank" rel="noopener">Ver archivo</a>
        </div>

        <div class="marcas-pago" aria-label="Métodos de pago aceptados">
          <span>Tarjetas aceptadas</span>
          <div class="tarjetas-aceptadas">
            <img src="assets/img/visa.png" alt="Visa">
            <img src="assets/img/masterCard.png" alt="Mastercard">
          </div>
        </div>

        <div class="metodos">
          <button type="button" [class.active]="metodo === 'card'" (click)="metodo = 'card'">Tarjeta</button>
          <button type="button" [class.active]="metodo === 'store'" (click)="metodo = 'store'">Pago en efectivo</button>
        </div>

        <form *ngIf="metodo === 'card'" id="openpay-payment-form" [formGroup]="paymentForm" (ngSubmit)="pagar()">
          <input type="hidden" id="device-session-id" name="device_session_id">
          <label>Nombre del titular</label>
          <input class="form-control" formControlName="holderName" data-openpay-card="holder_name" autocomplete="cc-name">

          <label>Número de tarjeta</label>
          <input class="form-control" formControlName="cardNumber" data-openpay-card="card_number" autocomplete="cc-number" inputmode="numeric">

          <div class="form-row">
            <div class="col">
              <label>Mes</label>
              <input class="form-control" formControlName="expirationMonth" data-openpay-card="expiration_month" maxlength="2" inputmode="numeric">
            </div>
            <div class="col">
              <label>Año</label>
              <input class="form-control" formControlName="expirationYear" data-openpay-card="expiration_year" maxlength="2" inputmode="numeric">
            </div>
            <div class="col">
              <label>CVV</label>
              <input class="form-control" formControlName="cvv2" data-openpay-card="cvv2" maxlength="4" type="password" inputmode="numeric">
            </div>
          </div>

          <button class="btn btn-warning btn-block" type="submit" [disabled]="procesando || !!montoError">
            <span *ngIf="procesando">Procesando...</span>
            <span *ngIf="!procesando">Pagar ${{montoPago | number:'1.2-2'}} con Openpay</span>
          </button>
        </form>

        <div *ngIf="metodo === 'store' && !referenciaEfectivo" class="pago-efectivo">
          <div class="sello-efectivo">
            <img src="assets/img/Sello_pago%20en%20efectivo_bco.png" alt="Pago en efectivo">
          </div>
          <p><strong>Generaremos una referencia para pagar en efectivo.</strong></p>
          <p>La referencia puede pagarse únicamente en estos establecimientos:</p>
          <ul class="tiendas-efectivo">
            <li>7-Eleven</li>
            <li>Walmart</li>
            <li>Farmacias del Ahorro</li>
            <li>Farmacias Benavides</li>
            <li>Sam's Club</li>
            <li>Bodega Aurrera</li>
          </ul>
          <button class="btn btn-warning btn-block" type="button" (click)="pagar()" [disabled]="procesando || !!montoError">
            <span *ngIf="procesando">Generando...</span>
            <span *ngIf="!procesando">Generar referencia por ${{montoPago | number:'1.2-2'}}</span>
          </button>
        </div>

        <div *ngIf="referenciaEfectivo" class="alert alert-success referencia">
          <strong>Referencia para pago en efectivo</strong>
          <span>{{referenciaEfectivo}}</span>
          <a *ngIf="fichaEfectivo" class="btn btn-info" [routerLink]="fichaEfectivo" target="_blank" rel="noopener">Ver ficha de pago</a>
        </div>

        <div class="procesado-openpay">
          <span>Transacciones realizadas vía</span>
          <img src="assets/img/LogotipoOpenpay-01.jpg" alt="Openpay">
        </div>
      </div>
    </div>
  </div>
</div>
